import React, { useState, useEffect, useContext } from 'react';
import './Broadcast.css';
import { ConfigProvider, Layout, Tabs, Flex, Typography } from 'antd';
import BroadcastContent from './components/BroadcastContent';
import LogsContent from './components/LogsContent';
import { ErrorMessageContext } from '../../context/ErrorMessageContext';
import { useNotification } from '../../context/NotificationContext';
import { ReactComponent as cancel } from '../../assets/icons/cancel.svg';
import { ReactComponent as cancelBlack } from '../../assets/icons/cancel-black.svg';
import Icon from '@ant-design/icons';
import { DARK } from '../../utilities/constants';
import { useTheme } from '../../context/ThemeContext';
import { formatDateTime } from '../../utilities/commonFunctions';

const { Content } = Layout;
const { Text } = Typography;

const Broadcast = () => {
  const { addErrorMessage, removeErrorMessage } =
    useContext(ErrorMessageContext);
  const [activeKey, setActiveKey] = useState('1');
  const shouldShowLastUpdated = activeKey === '1';

  const { isFirstLoginSession, cancelBroadcastNotification } =
    useNotification();
  const { theme } = useTheme();
  const [lastUpdatedTime, setLastUpdatedTime] = useState(Date.now());

  const addNotification = () => {
    if (isFirstLoginSession?.broadcast) {
      addErrorMessage(
        <Flex gap={16} align="center">
          <Text>The data shown here is of the last 24 hours.</Text>
          <Icon
            component={theme === DARK ? cancel : cancelBlack}
            onClick={() => {
              removeErrorMessage('broadcast-notification');
              cancelBroadcastNotification();
            }}
          />
        </Flex>,
        'notify',
        'broadcast-notification'
      );
    }
  };

  useEffect(() => {
    if (activeKey === '2') {
      removeErrorMessage('broadcast-notification');
    } else {
      addNotification();
    }
  }, [activeKey]);

  useEffect(() => {
    if (activeKey === '1') {
      addNotification();
    }
    return () => {
      removeErrorMessage('broadcast-notification');
    };
  }, [theme]);

  return (
    <ConfigProvider
      theme={{
        components: {
          Typography: {
            titleMarginBottom: 0,
            titleMarginTop: 0,
          },
          Layout: {
            siderBg: 'var(--secondary-fill-color, #2E3033)',
            headerBg: 'transparent',
            headerPadding: '0',
          },
          Form: {
            labelColonMarginInlineEnd: 0,
            labelColonMarginInlineStart: 0,
          },
        },
        token: {
          fontSize: '0.875rem',
        },
      }}
    >
      <Layout className="layout-page">
        <Content className="full-height">
          <Tabs
            type="card"
            size="large"
            className="full-height page-tabs"
            tabBarGutter="2rem"
            tabBarExtraContent={
              shouldShowLastUpdated ? (
                <Text className="last-updated-time">
                  {formatDateTime(lastUpdatedTime)}
                </Text>
              ) : null
            }
            tabBarStyle={{
              padding: '0 1rem',
            }}
            destroyOnHidden={false}
            defaultActiveKey="1"
            activeKey={activeKey}
            items={[
              {
                key: '1',
                label: 'Broadcast',
                children: (
                  <BroadcastContent
                    activeKey={activeKey}
                    setActiveKey={setActiveKey}
                    setLastUpdatedTime={setLastUpdatedTime}
                  />
                ),
              },
              {
                key: '2',
                label: 'Logs',
                children: <LogsContent />,
              },
            ]}
            onChange={activeKey => setActiveKey(activeKey)}
          />
        </Content>
      </Layout>
    </ConfigProvider>
  );
};

export default React.memo(Broadcast);
